/* ============================================================
   S3 Clothing — theme interactions
   Presentation behaviours from the static design, extended to
   drive live Shopify variants, the cart, and the mobile menu.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile hero "Read more" toggle ---------- */
  document.querySelectorAll('.hero-card').forEach(function (card) {
    var btn = card.querySelector('.hero-toggle');
    if (!btn) return;
    var label = btn.querySelector('.label');
    btn.addEventListener('click', function () {
      var open = card.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (label) label.textContent = open ? 'Show less' : 'Read more';
    });
  });

  /* ---------- Scroll reveal (collections tiles) ----------
     Opt-in via the js-reveal root class so tiles stay visible
     without JS or when the user prefers reduced motion. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    function observeTiles(scope) {
      var tiles = scope.querySelectorAll('[data-reveal]:not(.is-in)');
      if (!tiles.length) return;
      document.documentElement.classList.add('js-reveal');
      tiles.forEach(function (el, i) {
        el.style.animationDelay = (i % 4) * 70 + 'ms';
        io.observe(el);
      });
    }
    observeTiles(document);
    /* Theme editor re-renders a section's HTML on every setting change;
       the fresh tiles arrive unobserved and would stay hidden. */
    document.addEventListener('shopify:section:load', function (e) {
      observeTiles(e.target);
    });
  })();

  /* ---------- Mobile world-head toggle (ranges / captain's pick) ----------
     Delegated so it keeps working after theme editor section re-renders. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-world-view]');
    if (!btn) return;
    var pick = btn.dataset.worldView === 'pick';
    document.documentElement.classList.toggle('world-pick-m', pick);
    document.querySelectorAll('[data-world-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', (b.dataset.worldView === 'pick') === pick ? 'true' : 'false');
    });
  });

  /* ---------- Mobile grid view toggle (1-up / 2-up) ---------- */
  (function () {
    var KEY = 's3-plp-view';
    function apply(two) {
      document.documentElement.classList.toggle('plp-2up', two);
      document.querySelectorAll('[data-view-cols]').forEach(function (b) {
        b.setAttribute('aria-pressed', (b.dataset.viewCols === '2') === two ? 'true' : 'false');
      });
    }
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) { /* private mode */ }
    apply(stored === '2');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-cols]');
      if (!btn) return;
      var two = btn.dataset.viewCols === '2';
      apply(two);
      try { localStorage.setItem(KEY, two ? '2' : '1'); } catch (e2) { /* private mode */ }
    });
  })();

  /* ---------- Card quick-add (single-variant products) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var payload = { id: Number(btn.dataset.quickAdd), quantity: 1 };
    if (btn.dataset.preorderText) {
      payload.properties = { _preorder: btn.dataset.preorderText };
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = '(' + cart.item_count + ')';
        });
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  });

  /* ---------- Mobile nav toggle ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var header = btn.closest('[data-header]');
    var panel = header && header.querySelector('[data-mobile-nav]');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Desktop nav dropdowns ----------
     The markup is native <details>/<summary>, fully usable without this code.
     Here we add: hover-intent open/close (fine pointers only), one panel open
     at a time, Escape to close and refocus, and close on outside click or
     when keyboard focus leaves the panel. */
  var navDrops = Array.prototype.slice.call(document.querySelectorAll('[data-nav-drop]'));
  if (navDrops.length) {
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var closeOthers = function (current) {
      navDrops.forEach(function (d) {
        if (d !== current) d.removeAttribute('open');
      });
    };
    navDrops.forEach(function (drop) {
      var closeTimer;
      drop.addEventListener('toggle', function () {
        if (drop.open) closeOthers(drop);
      });
      drop.addEventListener('pointerenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeTimer);
        drop.setAttribute('open', '');
      });
      drop.addEventListener('pointerleave', function () {
        if (!hoverable.matches) return;
        closeTimer = setTimeout(function () { drop.removeAttribute('open'); }, 160);
      });
      drop.addEventListener('focusout', function (e) {
        if (!drop.contains(e.relatedTarget)) drop.removeAttribute('open');
      });
      drop.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drop.open) {
          drop.removeAttribute('open');
          var summary = drop.querySelector('summary');
          if (summary) summary.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      navDrops.forEach(function (d) {
        if (d.open && !d.contains(e.target)) d.removeAttribute('open');
      });
    });
  }

  /* ---------- PDP gallery — click a thumb to swap the main image ---------- */
  document.querySelectorAll('.gallery').forEach(function (g) {
    var main = g.querySelector('.main img');
    g.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var img = t.querySelector('img');
        if (main && img) {
          main.src = img.src.replace(/width=\d+/, 'width=1200');
          main.removeAttribute('srcset');
        }
      });
    });
  });

  /* ---------- Accordion ---------- */
  document.querySelectorAll('.acc-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc-item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    if (!input) return;
    var isCart = q.hasAttribute('data-cart-qty');
    var form = isCart ? q.closest('[data-cart-form]') : null;

    function commit() {
      if (form) { form.submit(); }
    }
    var dec = q.querySelector('.dec');
    var inc = q.querySelector('.inc');
    if (dec) dec.addEventListener('click', function () {
      var min = isCart ? 0 : 1;
      input.value = Math.max(min, (parseInt(input.value, 10) || 1) - 1);
      commit();
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 0) + 1;
      commit();
    });
    if (isCart) {
      input.addEventListener('change', commit);
    }
  });

  /* ---------- Product variant selection ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = root.querySelector('#product-form') || document.querySelector('#product-form');
    var dataEl = root.querySelector('[data-variants]');
    if (!form || !dataEl) {
      enableHighlightOnly(root);
      return;
    }

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('.pdp-info .price [data-price]') || root.querySelector('[data-price]');
    var priceWrap = priceEl ? priceEl.parentNode : null;
    var addBtn = form.querySelector('[data-add-btn]');
    var addLabel = form.querySelector('[data-add-label]');
    var preorderNotice = root.querySelector('[data-preorder-notice]');
    var preorderProp = form.querySelector('[data-preorder-prop]');

    function setPreorder(on) {
      if (preorderNotice) preorderNotice.hidden = !on;
      if (preorderProp) preorderProp.disabled = !on;
    }
    var mainImg = root.querySelector('.gallery .main img');
    var groups = root.querySelectorAll('[data-option-index]');

    function selectedValues() {
      var vals = [];
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        var active = group.querySelector('.is-active');
        vals[idx] = active ? active.getAttribute('data-option-value') : null;
      });
      return vals;
    }

    function matchVariant(vals) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === vals[i]; });
      });
    }

    function updateCompare(v) {
      if (!priceWrap) return;
      var compare = priceWrap.querySelector('[data-compare-price]');
      if (v.on_sale && v.compare_at) {
        if (priceEl) priceEl.classList.add('is-sale');
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'price-was';
          compare.setAttribute('data-compare-price', '');
          if (priceEl) priceEl.insertAdjacentElement('afterend', compare);
        }
        compare.textContent = v.compare_at;
      } else {
        if (priceEl) priceEl.classList.remove('is-sale');
        if (compare) compare.remove();
      }
    }

    function refreshOptionStates() {
      var vals = selectedValues();
      groups.forEach(function (group) {
        var idx = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('.swatch-dot, .size-pill').forEach(function (btn) {
          var value = btn.getAttribute('data-option-value');
          var anyAvailable = variants.some(function (v) {
            return v.available && v.options[idx] === value;
          });
          var comboAvailable = variants.some(function (v) {
            return v.available && v.options[idx] === value &&
              v.options.every(function (opt, i) {
                return i === idx || vals[i] === null || opt === vals[i];
              });
          });
          if (anyAvailable) {
            btn.removeAttribute('aria-disabled');
            btn.classList.toggle('is-unavailable', !comboAvailable);
          } else {
            btn.setAttribute('aria-disabled', 'true');
            btn.classList.remove('is-unavailable');
          }
          var soldOut = !anyAvailable || !comboAvailable;
          if (soldOut) {
            btn.setAttribute('title', 'Sold out');
          } else {
            btn.removeAttribute('title');
          }
          if (btn.classList.contains('swatch-dot')) {
            var base = btn.getAttribute('data-base-label');
            if (!base) {
              base = btn.getAttribute('aria-label') || value;
              btn.setAttribute('data-base-label', base);
            }
            btn.setAttribute('aria-label', soldOut ? base + ' (sold out)' : base);
          }
        });
      });
    }

    function update() {
      var v = matchVariant(selectedValues());
      if (!v) {
        if (addBtn) {
          addBtn.setAttribute('disabled', '');
          if (addLabel) addLabel.textContent = 'Unavailable';
        }
        setPreorder(false);
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl && v.price) priceEl.textContent = v.price;
      updateCompare(v);
      if (addBtn) {
        if (v.available) {
          addBtn.removeAttribute('disabled');
          if (addLabel) {
            addLabel.textContent = v.preorder
              ? (addBtn.getAttribute('data-label-preorder') || 'Pre-order')
              : (addBtn.getAttribute('data-label-add') || 'Add to bag');
          }
        } else {
          addBtn.setAttribute('disabled', '');
          if (addLabel) addLabel.textContent = 'Sold out';
        }
      }
      setPreorder(!!(v.available && v.preorder));
      if (mainImg && v.image) {
        mainImg.src = v.image;
        mainImg.removeAttribute('srcset');
        root.querySelectorAll('.thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') == v.media_id);
        });
      }
    }

    root.querySelectorAll('.swatches, .sizes').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var opt = e.target.closest('.swatch-dot, .size-pill');
        if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
        group.querySelectorAll('.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        opt.classList.add('is-active');
        refreshOptionStates();
        update();
      });
    });

    refreshOptionStates();
  });

  /* ---------- Article contents list ----------
     Built from the article's H2s when there are three or more, so it
     appears on long guides and stays off short stories. */
  (function () {
    var body = document.querySelector('.article-body');
    var toc = document.querySelector('.article-toc');
    if (!body || !toc) return;
    var heads = body.querySelectorAll('h2');
    if (heads.length < 3) return;
    var list = toc.querySelector('ol');
    var details = toc.querySelector('details');
    heads.forEach(function (h) {
      if (!h.id) {
        var slug = h.textContent.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
        var id = slug;
        var n = 2;
        while (document.getElementById(id)) id = slug + '-' + n++;
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
    toc.parentNode.classList.add('has-toc');
    /* open beside the text on desktop, collapsed above it on small screens */
    var wide = window.matchMedia('(min-width: 1100px)');
    function sync() { details.open = wide.matches; }
    sync();
    wide.addEventListener('change', sync);
  })();

  /* ---------- Fallback: highlight-only pickers (no variant data) ---------- */
  function enableHighlightOnly(scope) {
    (scope || document).querySelectorAll('.swatches, .sizes').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var opt = e.target.closest('.swatch-dot, .size-pill');
        if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
        group.querySelectorAll('.is-active').forEach(function (x) { x.classList.remove('is-active'); });
        opt.classList.add('is-active');
      });
    });
  }
})();
